const info = {
  appName: 'Monk Capture Application',
  shortName: 'MCA',
  companyName: 'Monk',
  logo: {
    source: {
      uri: 'logo_default.png',
    },
    width: 160,
    height: 71,
  },
  description: 'Monk Capture App enables high level car inspections with helpers and specific user interfaces.',
  vm: false,
  resolution: 'QHD'
};

export default info;
